import Axios from 'axios'
import { SelectBox } from 'devextreme-react'
import Cookies from 'js-cookie'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { Alert, Button, Card, Col, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import { useAuth } from '../../auth'
import Breadcrumb from '../../components/common/breadcrumb'
import { downloadSampleExcel } from '../../components/common/excel-upload/excel-upload'
import { goRiceUrl } from '../../constant/siteConstants'
import api from '../../services/api-configuration'
import { getAllWarehouses } from '../../services/apis'
import useFormatMessage from '../../utils/useFormatMessage'
const DepolarArasiTransfer = () => {
    const { t } = useFormatMessage()
    const [file, setFile] = useState(null)
    const [sevkiyatYerleri, setSevkiyatYerleri] = useState([])
    const [orderList, setOrderList] = useState([])
    const [warehouseList, setWarehouseList] = useState([])
    const [isWarningModalOpen, setIsWarningModalOpen] = useState(false)
    const [warningMessage, setWarningMessage] = useState()
    const [sourceWarehouse, setSourceWarehouse] = useState(null)
    const [targetWarehouse, setTargetWarehouse] = useState(null)
    const fileInputRef = React.createRef()
    const [confirmation, setConfirmation] = useState(false)
    const [disabledSave, setDisabledSave] = useState(false)
    const [disabledModal, setDisabledModal] = useState(false)

    const { hasRole } = useAuth(22);
    useEffect(() => {
        getOrderList()
        fetchData()
        getAllWarehousesData()
    }, [])

    const handleFileChange = (e) => {
        const file = e.target.files[0]
        setFile(file)
    }

    const clearFile = () => {
        setFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        // Ek olarak input elementini de sıfırlayabiliriz
        const fileInput = document.getElementById('excelUpload');
        if (fileInput) {
            fileInput.value = '';
        }
    };

    const fetchData = async () => {
        try {
            const response = await api.post("/shippingLocation/getAll");
            let allData = response.data.data || []
            setSevkiyatYerleri(allData.filter(item =>
                item.is_active === true && item.code !== "SY000002"
            ));
        } catch (error) {
            console.error("Error fetching locations:", error);
            toast.error(t("Hata oluştu"));
        }
    };

    const handleSourceWarehouseChange = (e) => {
        if (e.value === targetWarehouse) {
            toast.error(t("Çıkış deposu ve varış deposu aynı olamaz!"))
            setSourceWarehouse(null)
            return
        }
        setSourceWarehouse(e.value)
    }

    const handleTargetWarehouseChange = (e) => {
        if (e.value === sourceWarehouse) {
            toast.error(t("Çıkış deposu ve varış deposu aynı olamaz!"))
            setTargetWarehouse(null)
            return
        }
        setTargetWarehouse(e.value)
    }

    const getOrderList = async () => {
        try {
            const response = await api.post("orderType/getAll")
            setOrderList(response.data.data || [])
        } catch (error) {
            let error_message = error.response?.data?.error || ""
            console.error(error)
            toast.error("Hata: " + error_message)
        }
    }
    const [message, setMessage] = useState([])
    const getAllWarehousesData = async () => {
        try {
            const res = await getAllWarehouses(true);
            setWarehouseList(res)
        } catch (err) {
            setWarehouseList([])
            console.error(err)
        }
    }
    let headers = {
        'Content-Type': 'multipart/form-data',
        token: Cookies.get('token')
    };

    const validateWarehouseSelection = () => {
        if (!sourceWarehouse || !targetWarehouse) {
            toast.error(t("Lütfen çıkış ve varış depolarını seçiniz"))
            return false
        }
        return true
    }

    const handleSave = async () => {
        if (!file) {
            toast.error(t("Lütfen bir Excel dosyası seçiniz"))
            return
        }

        if (!validateWarehouseSelection()) {
            return
        }

        setDisabledSave(true)

        let message = []
        try {
            const formData = new FormData()
            formData.append('file', file)
            formData.append('transfer_confirmation', null)
            formData.append('user_id', parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')))
            formData.append('process_type', "WAREHOUSE_TRANSFER");
            formData.append('target_warehouse_id', targetWarehouse);
            formData.append('located_warehouse_id', sourceWarehouse);

            const checkResponse = await Axios.post(`${goRiceUrl}/api/vehicle/add`, formData, { headers });

            if (checkResponse.data.stats.failed > 0) {
                message = checkResponse.data.results.filter((item) => item.error !== null)
                setMessage(message)
                setWarningMessage(message)
                setIsWarningModalOpen(true)
            }
            else {
                await uploadExcel(1)
            }
        } catch (error) {
            let errorMessage = error.response?.data?.error?.replace("file processing error: failed to transform data:", "") || t("Dosya yüklenirken bir servis hatası oluştu.");
            console.error('Error:', error)
            toast.error(t("İşlem sırasında hata oluştu") + errorMessage, {
                autoClose: 20000
            })
        } finally {

            setTimeout(() => {
                setDisabledSave(false)
            }, 300);

        }
    }

    const uploadExcel = async (control) => {
        let result = control === true ? "1" : control === false ? "0" : control
        setDisabledModal(true)
        try {
            const formData = new FormData()
            formData.append('file', file)
            formData.append('transfer_confirmation', result)
            formData.append('user_id', parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')))
            formData.append('process_type', "WAREHOUSE_TRANSFER");
            formData.append('target_warehouse_id', targetWarehouse);
            formData.append('located_warehouse_id', sourceWarehouse);

            const response = await Axios.post(`${goRiceUrl}/api/vehicle/add`, formData, { headers });

            if (response.data.success) {
                toast.success(t("Dosya başarıyla yüklendi"))
                clearFile()
            } else {
                toast.error(t("Dosya yüklenirken hata oluştu"))
            }
        } catch (error) {
            console.error('Error:', error)
            toast.error(t("Dosya yüklenirken hata oluştu"))
        } finally {
            setIsWarningModalOpen(false)
            setTimeout(() => {
                setDisabledModal(false)
            }, 300);

        }
    }

    const getWarehouseName = (id) => {
        const warehouse = warehouseList.find(w => w.id === id)
        return warehouse ? warehouse.warehouse_name : ''
    }

    return (
        <>
            <Breadcrumb current={t("Depolar Arası Transfer")} />

            <Card>
                <Row className='p-3'>
                    <Col md="12" style={{ textAlign: "right" }}>
                        <p>
                            <b>
                                {t("Yüklemek İstediğiniz Excel Dosyasını seçiniz. Excel Şablonunu")}
                                <span onClick={() => downloadSampleExcel(["sase"], "", "DepolarArası Transfer")} style={{ color: "blue", cursor: "pointer" }}>
                                    &nbsp;{t("buradan")}&nbsp;
                                </span>
                                {t("indirebilirsiniz")}.
                            </b>
                        </p>
                    </Col>

                    <Col md="12">
                        <FormGroup style={{ gap: "20px" }} className='d-flex align-items-center m-2'>
                            <Label for="islem-tipi" className='m-0'><b>{t("Excel Yükle")}</b></Label>
                            <InputGroup>
                                <Input
                                    id="excelUpload"
                                    type="file"
                                    accept=".xlsx, .xls"
                                    onChange={handleFileChange}
                                    style={{ display: 'none', height: "100%" }}
                                    ref={fileInputRef}
                                />
                                <Input
                                    type="text"
                                    placeholder="Choose file..."
                                    value={file ? file.name : ''}
                                    readOnly
                                    style={{ height: "auto" }}
                                />
                                <InputGroupAddon addonType="append" onClick={clearFile}>
                                    <InputGroupText>
                                        <Label for="excelUpload" style={{ cursor: 'pointer', marginBottom: 0 }}>Seç</Label>
                                    </InputGroupText>
                                </InputGroupAddon>
                            </InputGroup>
                        </FormGroup>
                    </Col>
                </Row>

                <Row className='p-3'>
                    <Col>
                        <FormGroup style={{ gap: "20px" }} className='d-flex align-items-center m-2'>
                            <Label for="islem-tipi" className='m-0'><b>{t("Çıkış Deposu")}</b></Label>
                            <SelectBox
                                id='source_warehouse_id'
                                style={{ width: "100%" }}
                                dataSource={warehouseList?.length > 0 && warehouseList
                                    .filter(item => item.id !== 34)
                                }
                                valueExpr="id"
                                displayExpr="warehouse_name"
                                value={sourceWarehouse}
                                onValueChanged={handleSourceWarehouseChange}
                                placeholder={t("Çıkış deposu seçiniz")}
                            />
                        </FormGroup>
                    </Col>

                    <Col>
                        <FormGroup style={{ gap: "20px" }} className='d-flex align-items-center m-2'>
                            <Label for="islem-tipi" className='m-0'><b>{t("Varış Deposu")}</b></Label>
                            <SelectBox
                                id='target_warehouse_id'
                                style={{ width: "100%" }}
                                dataSource={warehouseList}
                                valueExpr="id"
                                displayExpr={
                                    (item) => {
                                        if (item?.id === 34) {
                                            return item?.warehouse_name + " (DIŞ DEPO)"
                                        } else return item?.warehouse_name
                                    }
                                }
                                value={targetWarehouse}
                                onValueChanged={handleTargetWarehouseChange}
                                placeholder={t("Varış deposu seçiniz")}
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <hr />

                <Row className='p-3'>
                    <Col md="12" className='mb-2'>
                        <span style={{ color: "blue", fontWeight: "bold" }}>
                            {t("Excel Dosyasında bulunması gereken kolonlar")}:
                        </span>
                    </Col>
                    <Col md="12" className='m-1'>
                        <table className="table table-bordered">
                            <thead>
                                <tr style={{ backgroundColor: "#e2e2e2" }}>
                                    <th style={{ border: "1px solid rgb(208 208 208)" }}>
                                        {t("sase")} &nbsp;
                                        <span style={{ color: "red" }}>*</span>
                                    </th>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid rgb(208 208 208)" }}>VR3USHNS2RJ929343</td>
                                </tr>
                            </thead>
                        </table>
                    </Col>
                </Row>

                <Row className='p-3'>
                    <Col style={{ display: "flex", justifyContent: "flex-end" }}>
                        {
                            hasRole("depolararasi_emir_write") &&
                            <Button
                                id='save-button'
                                disabled={disabledSave || !file || !sourceWarehouse || !targetWarehouse}
                                onClick={() => {
                                    if (targetWarehouse === 34) setConfirmation(true)
                                    else handleSave()
                                }}>{t("Kaydet")}</Button>}
                        <Button color="danger" className="ml-2">{t("İptal")}</Button>
                    </Col>
                </Row>
            </Card>
            <Modal isOpen={isWarningModalOpen} toggle={() => setIsWarningModalOpen(false)}
                size="lg"
            >
                <ModalBody>
                    <p style={{
                        fontSize: "1rem", lineHeight: "1.5",
                        background: "#e6e6e6",
                        padding: "15px",
                    }}>
                        <span style={{ color: "red", fontWeight: "bold" }}>! </span>
                        <strong>Uyumsuz Araçlar:</strong> Listelenmiştir.
                        <span style={{ fontWeight: "bold" }}>Uyumlu araçlar</span> için işlem yapabilirsiniz.
                        Uyumsuz araçlar üzerinde işlem yapmak isterseniz
                        <span style={{ color: "red", fontWeight: "bold" }}> Tümünü Zorla</span> seçeneğini kullanabilirsiniz.
                        <br />
                        <span style={{ color: "green", fontWeight: "bold" }}>✓ </span>
                        <strong>Uyumluları Al:</strong>
                        Bu seçenek, yalnızca uyumlu araçlar üzerinde işlem yapılmasını sağlar. Uyumsuz ve hatalı araçlar işlem kapsamı dışında bırakılır.
                        <br />
                        <span style={{ color: "red", fontWeight: "bold" }}>! </span>
                        <strong>Hatalı Araçlar:</strong>
                        Bu araçlar üzerinde işlem yapılamaz. "Tümünü Zorla" seçeneğini kullansanız bile bu araçlar işleme alınmaz. Excel üzerindeki hatalar düzeltilip eklenmelidir
                    </p>

                    <div style={{ display: "flex", alignItems: "center", marginTop: "1rem" }}>
                        <span
                            style={{
                                display: "inline-block",
                                background: "rgb(255 231 180)",
                                width: "30px",
                                height: "30px",
                                border: "1px solid #ccc",
                                borderRadius: "50%",
                            }}
                        ></span>
                        <span
                            style={{
                                marginLeft: "0.5rem",
                                marginRight: "2rem",
                                fontSize: "1rem",
                                fontWeight: "bold",
                                // color: "blue",
                            }}
                        >
                            {t("Uyumsuz Araçlar")}
                        </span>
                        <span
                            style={{
                                display: "inline-block",
                                background: "rgb(211 71 71)",
                                width: "30px",
                                height: "30px",
                                border: "1px solid #ccc",
                                borderRadius: "50%",
                            }}
                        ></span>
                        <span
                            style={{
                                marginLeft: "0.5rem",
                                fontSize: "1rem",
                                fontWeight: "bold",
                                // color: "red",
                            }}
                        >
                            Hatalı Araçlar
                        </span>
                    </div>


                    <table
                        style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            borderSpacing: "0",
                            textAlign: "center",
                            border: "1px solid #ddd",
                            borderRadius: "5px",
                            overflow: "hidden",
                            marginBottom: "10px",
                        }}
                    >
                        <tr
                            style={{
                                backgroundColor: "#f2f2f2",
                            }}
                        >
                            <th style={{ textAlign: "left", padding: "8px" }}>{t("Şasi No")}</th>
                            <th style={{ textAlign: "left", padding: "8px" }}>{t("Hata")}</th>
                        </tr>
                        {
                            warningMessage?.length > 0 &&
                            warningMessage.map((item, index) => {
                                if (item.error) {
                                    return (
                                        <tr key={index}>
                                            <td style={{ textAlign: "left", padding: "8px" }}>{item.chassis_no}</td>
                                            <td style={{
                                                textAlign: "left", padding: "8px",
                                                backgroundColor: item.error?.startsWith("vehicle is in:") ? "rgb(255 231 180)" : "rgb(211 71 71)",
                                                color: item.error?.startsWith("vehicle is in:") ? "black" : "white"
                                            }}
                                            >{
                                                    item.error?.startsWith("vehicle is in:") ? "Araç " + item.error.split(":")[1] + " Deposunda" : t(item.error)
                                                }</td>
                                        </tr>
                                    )
                                }
                            })
                        }
                    </table>
                </ModalBody>
                <ModalFooter>
                    <Button disabled={!(warningMessage?.some(item => item.error?.startsWith("vehicle is in:"))) || disabledModal} color="danger" onClick={() => uploadExcel(1)}>
                        {disabledModal ? t("İşleniyor...") : t("Tümünü Zorla")}
                    </Button>
                    <Button
                        disabled={!(warningMessage?.some(item => item.error?.startsWith("vehicle is in:"))) || disabledModal}
                        color="primary" onClick={() => uploadExcel(0)}>
                        {disabledModal ? t("İşleniyor...") : t("Uyumluları Al")}
                    </Button>
                    <Button color="secondary" onClick={() => setIsWarningModalOpen(false)} disabled={disabledModal}>
                        {
                            warningMessage?.some(item => item.error?.startsWith("vehicle is in:")) ?
                                t("Vazgeç") : t("Tamam")
                        }
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={confirmation} toggle={() => setConfirmation(!confirmation)}
                size='lg'
            >
                <ModalHeader>
                    DIŞ DEPO TRANSFER ONAYI
                </ModalHeader>

                <ModalBody>
                    <div className="p-4" style={{ backgroundColor: '#fff' }}>
                        <Alert
                            color="warning"
                            className="mb-4 border-2"
                            style={{
                                backgroundColor: '#fff3cd',
                                borderColor: '#ffeeba',
                                color: '#856404'
                            }}
                        >
                            <div className="d-flex align-items-center">
                                <i className="fa fa-exclamation-triangle fa-2x me-3" style={{ color: '#856404' }}></i>
                                <div>
                                    {/* <h5 className="alert-heading mb-2" style={{ color: '#856404' }}>
                                        Önemli Bilgilendirme
                                    </h5> */}
                                    <p className="mb-0" style={{ color: '#856404', fontSize: '1.1rem' }}>
                                        Seçilen şaseler dış depoya transfer edilecektir. Bu işlem tamamlandığında, şaseler stok kaydınızdan otomatik olarak düşecektir.
                                    </p>
                                </div>
                            </div>
                        </Alert>

                        <div
                            className="text-center p-3 rounded border"
                            style={{
                                backgroundColor: '#e9ecef',
                                borderColor: '#dee2e6'
                            }}
                        >
                            <p className="fw-bold fs-5 mb-0" style={{ color: '#495057', fontSize: '1.1rem' }}>
                                Onaylıyor musunuz?
                            </p>
                        </div>
                    </div>

                </ModalBody>
                <ModalFooter>
                    <Button className='mr-1' color="primary" onClick={() => {
                        handleSave()
                        setConfirmation(!confirmation)
                    }}>Onayla</Button>
                    <Button color="danger" onClick={() => setConfirmation(!confirmation)}>Vazgeç</Button>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default DepolarArasiTransfer